import * as helper from './../../../../VX/View/Assets/Js/helper';

export function initImprint(imprintLink: Element, privacyLink: Element) {
	const overlay = helper.$('#overlay');
	const imprint = helper.$('#imprint');
	const privacy = helper.$('#privacy');

	helper.addClickListener(imprintLink, (e:MouseEvent) => {
		e.preventDefault();
		helper.show(overlay);
		helper.show(imprint);
		helper.hide(privacy);
	})

	helper.addClickListener(privacyLink, (e:MouseEvent) => {
		e.preventDefault();
		helper.show(overlay);
		helper.hide(imprint);
		helper.show(privacy);
	})

	helper.addClickListener(helper.$('#closeButton'), (e:MouseEvent) => {
		e.preventDefault();
		helper.hide(overlay);
	})
}
